import React from 'react'

interface DividerProps {
  className?: string
}

const Divider: React.FC<DividerProps> = ({ className }) => (
  <svg
    className={className}
    width="1"
    height="20"
    viewBox="0 0 1 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="1" height="20" fill="#B2AEB0" />
  </svg>
)

export default Divider
